var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashtagSignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.88 122.88",
    style: {
      enableBackground: "new 0 0 99.88 122.88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.92,4.32c0.6-2.89,3.43-4.74,6.32-4.14c2.89,0.6,4.74,3.43,4.14,6.32l-6.09,29.31h28.77l6.56-31.55 c0.6-2.89,3.43-4.74,6.32-4.14c2.89,0.6,4.74,3.43,4.14,6.32l-6.11,29.38h13.56c2.96,0,5.35,2.4,5.35,5.35s-2.4,5.35-5.35,5.35 H78.74l-6.73,32.35h22.51c2.96,0,5.35,2.4,5.35,5.35c0,2.96-2.4,5.35-5.35,5.35H69.79l-6.04,29.05c-0.6,2.89-3.43,4.74-6.32,4.14 c-2.89-0.6-4.74-3.43-4.14-6.32l5.59-26.88H30.1l-6.01,28.92c-0.6,2.89-3.43,4.74-6.32,4.14c-2.89-0.6-4.74-3.43-4.14-6.32 l5.56-26.75H5.35C2.4,89.57,0,87.17,0,84.22c0-2.96,2.4-5.35,5.35-5.35h16.06l6.73-32.35H5.35C2.4,46.52,0,44.12,0,41.16 s2.4-5.35,5.35-5.35h25.02L36.92,4.32L36.92,4.32z M61.1,78.86l6.73-32.35H39.05l-6.73,32.35H61.1L61.1,78.86z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtagSignIcon);
export default __webpack_public_path__ + "static/media/hashtag-sign-icon.5fb4d8a314cd32a92b8b8267c225df52.svg";
export { ForwardRef as ReactComponent };